import { AnswerRepository } from "../../../../data/repository/answer/AnswerRepository";
import { Answer } from "../../../model/Question";
import { ResponseState, State } from "../../../model/ResponseState";

export interface GetAnswersByListOfQuestionsIdUseCase {
  invoke: (questionsId: string) => Promise<ResponseState<Array<Answer>>>;
}

export class GetAnswersByListOfQuestionsIdUseCaseImpl
  implements GetAnswersByListOfQuestionsIdUseCase
{
  private answerRepository: AnswerRepository;

  constructor(answerRepository: AnswerRepository) {
    this.answerRepository = answerRepository;
  }

  async invoke(questionsId: string): Promise<ResponseState<Array<Answer>>> {
    try {
      let response = await this.answerRepository.getAnswersByListOfQuestionsId(
        questionsId
      );
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
